<!--
    描述：考核系统 --- 考核
    时间：2021-03-10
    Created by 王帅
    updated by 钱磊 2022-5-18 11:05:04
-->
<template>
    <div class="mark-layout">
        <div class="h100">
            <iframe
                ref="iframePage"
                :src="iframeUrl"
                frameborder="0"
                height="100%"
                width="100%"
                @load="onLoad()"
            ></iframe>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    mounted() {
        let that = this
        // 接受父页面发来的信息
        window.addEventListener("message", function (event) {
            var data = event.data;
            if (data.fromChild) {
                console.log(data)
                // that.doSubmit(data);
            }
        });
    },
    methods: {
        // iframe 传参
        onLoad() {
            let params = {
                busId: parseInt(Math.random() * 10000), //----业务表ID（业务调用模块传该参数）
                // busId: "68", //----业务表ID（业务调用模块传该参数）
                judgerId: "111", //----考核人id
                judger: "ws", //----考核人姓名
                judgeUnit: "123", //----考核人所属单位id
                judgeType: 1,   // 1 企业 0 个人
                unitName: "本末", //----考核人所属单位名
                beJudgeUnit: "1234", //----被考核人所属单位id
                beJudgerId: "222", //----被考核人id
                beJudger: "zzh", // ----被考核人姓名
                beUnitName: "鼎信", //----被考核人所属单位名
                beJudgeType: 0, // 1 企业 0 个人
                judgeRole: "1008003", //----考核人角色(码表)
                judgeRoleName: '投标人',
                beJudgeRole: "1008004", //----被考核人角色(码表)
                beJudgeRoleName: '专家评委',
                markObj: "1007001", //----考核对象(码表)
                markObjName: '标段评审',
                objName: '中国科技大学宿舍改造采购',
                source: "1009003", //----适用业务（码表）
                totalScore: 0, //----合计考核
                ruleItems:[],
            };
            setTimeout(() => {
                this.$refs.iframePage.contentWindow.postMessage(params, "*");
            }, 2000);
        },
    },
    computed: {
        // iframe 地址
        iframeUrl() {
            let origin = window.location.origin
            // return `http://172.16.0.14:8601/#/evaluate-mark-open`
            return `${origin}/BmServiceAdmin/#/evaluate-mark-open`
        },
    },
};
</script>

<style scoped lang="less">
.mark-layout {
    height: 100%;
    background-color: #fff;
    overflow-y: auto;

    .header {
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        text-align: center;
    }
}
</style>
